export default __webpack_public_path__ + "static/media/events.eeca89db.webp";